var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconRemove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 12.5C25 5.5965 19.4035 0 12.5 0C5.5965 0 0 5.5965 0 12.5C0 18.362 4.036 23.281 9.4805 24.632V16.32H6.903V12.5H9.4805V10.854C9.4805 6.5995 11.406 4.6275 15.583 4.6275C16.375 4.6275 17.7415 4.783 18.3005 4.938V8.4005C18.0055 8.3695 17.493 8.354 16.8565 8.354C14.807 8.354 14.015 9.1305 14.015 11.149V12.5H18.098L17.3965 16.32H14.015V24.9085C20.2045 24.161 25.0005 18.891 25.0005 12.5H25Z",
    fill: "#0866FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3958 16.32L18.0973 12.5H14.0143V11.149C14.0143 9.1305 14.8063 8.354 16.8558 8.354C17.4923 8.354 18.0048 8.3695 18.2998 8.4005V4.938C17.7408 4.7825 16.3743 4.6275 15.5823 4.6275C11.4053 4.6275 9.47984 6.5995 9.47984 10.854V12.5H6.90234V16.32H9.47984V24.632C10.4468 24.872 11.4583 25 12.4993 25C13.0118 25 13.5173 24.9685 14.0138 24.9085V16.32H17.3953H17.3958Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRemove);
export default __webpack_public_path__ + "static/media/iconRemove.c98d5dd0b2e3b03cf4d753e6489175ad.svg";
export { ForwardRef as ReactComponent };